@if (data?.action == 'open_follicle_chart'&&utilService.isMobile() &&viewMobileChart) {
    <div>
      <div class="legend">
        <div class="legend-item">
          <span class="legend-color left"></span>
          <span>Left Ovary</span>
        </div>
        <div class="legend-item">
          <span class="legend-color right"></span>
          <span>Right Ovary</span>
        </div>
      </div>
    </div>
  }
  @if (data?.action == 'open_follicle_chart'&&utilService.isMobile() &&viewMobileChart) {
    <div class="follicle-wrapper">
      <div class="chart-container">
        <div class="y-title">
          Follicle Size (mm)
        </div>
        <div class="y-axis">
          @for (y of yAxis; track y) {
            <div [style.bottom.%]="getYPosition(y)">
              {{ y === 18 ? '>=18' : (y === 20 ? '' : y) }}
            </div>
          }
        </div>
        <!--  SCROLLABLE AREA -->
        <div class="chart-scroll" #scrollContainer>
          @if (showScrollHint) {
            <div class="scroll-hint">
              <span>Swipe →</span>
            </div>
          }
          <div class="chart-area">
            <div class="grid"></div>
            @for (p of mobilePoints; track p) {
              <div class="bubble" [ngClass]="[p.type, p.sizeValue >= 18 ? 'high' : '']"
                [style.left.%]="p.xPercent" [style.bottom.%]="p.yPercent" [style.width.px]="p.size"
                [style.height.px]="p.size" (mouseenter)="showTooltip1(p, $event)" (mouseleave)="hideTooltip1()"
                (click)="showTooltip1(p, $event)">
                {{ p.count }}
              </div>
            }
          </div>
          <!-- X AXIS -->
          <div class="x-axis">
            @for (d of days; track d) {
              <div>Day {{ d }}</div>
            }
          </div>
          <div class="x-title">
            Scan Day
          </div>
        </div>
      </div>
    </div>
  }
  
  @if (data?.action == 'open_follicle_chart'&& !utilService.isMobile()  ) {
    <div class="p-3">
      @if (config.chartData!=undefined && config.chartData.length>0) {
        <app-chart [chartDataSets]="config.chartData"
          [chartOptions]="config.chartOptions" [chartLegend]="true" [chartType]="'bubble'" [chartLabels]="[]"
        [chartColors]='[]' [chartPlugins]="chartPlugins"></app-chart>
      }
    </div>
  }
  @if (data?.action == 'open_follicle_data') {
    <div>
      @if (finalData &&fields&&fields.length>0 ) {
        <dhs-data-grid [data]="finalData" [fields]="fields"
          [config]="dataGridConfig" (onLimitChange)="onLimit($event)" (onPageChanges)="onPageChanged($event)">
        </dhs-data-grid>
      }
    </div>
  }
  @if (tooltip.visible && viewMobileChart) {
    <div class="tooltip1" [style.left.px]="tooltip.x" [style.top.px]="tooltip.y">
      <div class="title">Day {{ tooltip.day }}</div>
      <div class="content">
        {{ tooltip.label }}: {{ tooltip.count }} follicle{{ tooltip.count > 1 ? 's' : '' }} ({{ tooltip.size }} mm)
      </div>
    </div>
  }